import { Input } from "antd";
import { SearchIcon } from "../../assets";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getCommonState } from "../../redux/store/getState";
import { setHeaderSearchValue } from "../../redux/apiSlice/commonSlice";

export default function HeaderSearch() {
  const dispatch = useAppDispatch();
  const { headerSearch } = useAppSelector(getCommonState);

  function handleSearch(value: string) {
    dispatch(setHeaderSearchValue({ value }));
  }

  if (headerSearch.title === "home") return null;
  return (
    <div className="header_search_container">
      <Input
        value={headerSearch.value}
        placeholder={`Search in ${headerSearch.title}`}
        prefix={<SearchIcon width="20" style={{ marginRight: 5 }} />}
        onChange={(e) => handleSearch(e.target.value)}
      />
    </div>
  );
}
